/**
 * Dev-gated console helpers. Calls are dropped in production builds so
 * service-failure noise doesn't leak to end-user devtools.
 *
 * Surface a real error to the user via Snackbar / a UI banner, not via
 * console.error. Use these only for developer-facing diagnostics.
 */

export const devWarn = (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
        console.warn(...args);
    }
};

export const devError = (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
        console.error(...args);
    }
};

export const devLog = (...args: unknown[]): void => {
    if (import.meta.env.DEV) {
        // eslint-disable-next-line no-console
        console.log(...args);
    }
};
